import { gql } from '@apollo/client';

export const INVITE_TO_ESTORE_ENROLL = gql`
  mutation USER_SERVICE_inviteToEStoreEnroll($user: InputSEUser!) {
    inviteToEStoreEnroll(user: $user) {
      id
    }
  }
`;
